import React from 'react';
import styles from './Modal.module.css';

const Modal = (props) => {
    const {
        children,
        size = 'sm',
        active,
        className = '',
        contentClassName = '',
        toggler,
    } = props;

    return (
        <>
            {active ? (
                <>
                    <div
                        className={`fixed inset-0 z-50 flex items-start justify-center overflow-x-hidden overflow-y-auto px-3 py-3 outline-none focus:outline-none sm:items-center sm:px-6 sm:py-6`}>
                        <div
                            className={`relative mx-auto w-full max-w-full ${
                                size !== 'regular' ? styles[size] : ''
                            } ${className}`}>
                            <div
                                id="modal"
                                className={`border-0 shadow-lg py-4 relative rounded-xl flex flex-col w-full bg-white outline-none focus:outline-none ${contentClassName}`}>
                                {children}
                            </div>
                        </div>
                    </div>
                    <div
                        className="fixed inset-0 z-40 bg-gray-700 opacity-40"
                        onClick={toggler}></div>
                </>
            ) : null}
        </>
    );
};

export default Modal;
